
export enum LocalStorageKeys {
    JWT_KEY = 'jwt',
    COOKIE_ACCEPTED = 'cookie-accepted',
}